import { gql } from "@urql/core";

const queryArtikel = gql`
  query MyQuery(
    $limit: Int
    $offset: Int
    $order: [cms_articles_order_by!]
    $title: String
  ) {
    cms_articles(
      where: { title: { _ilike: $title } }
      limit: $limit
      offset: $offset
      order_by: $order
    ) {
      id
      title
      description
      created_at
      picture
      url
    }
    cms_articles_aggregate(where: { title: { _ilike: $title } }) {
      aggregate {
        count
      }
    }
  }
`;

const queryAcara = gql`
  query MyQuery(
    $limit: Int
    $offset: Int
    $order: [cms_events_order_by!]
    $title: String
    $date: timestamptz
  ) {
    cms_events(
      where: { title: { _ilike: $title }, time: { _gte: $date } }
      limit: $limit
      offset: $offset
      order_by: $order
    ) {
      id
      title
      location
      created_at
      picture
      time
      url
      description
    }
    cms_events_aggregate(
      where: { title: { _ilike: $title }, time: { _gte: $date } }
    ) {
      aggregate {
        count
      }
    }
  }
`;

const queryBerita = gql`
  query MyQuery(
    $limit: Int
    $offset: Int
    $order: [cms_news_order_by!]
    $title: String
  ) {
    cms_news(
      where: { title: { _ilike: $title } }
      limit: $limit
      offset: $offset
      order_by: $order
    ) {
      id
      title
      created_at
      picture
      url
    }
    cms_news_aggregate(where: { title: { _ilike: $title } }) {
      aggregate {
        count
      }
    }
  }
`;

const queryEBrocure = gql`
  query MyQuery($limit: Int, $offset: Int, $order: [cms_promotions_order_by!]) {
    cms_promotions(
      limit: $limit
      offset: $offset
      order_by: $order
      where: { deleted_at: { _is_null: true } }
    ) {
      link
      id
      url
      program
      title
      description
      created_at
    }
  }
`;

const queryPrestasi = gql`
  query MyQuery(
    $limit: Int
    $offset: Int
    $order: [cms_achievements_order_by!]
    $title: String
  ) {
    cms_achievements(
      where: { title: { _ilike: $title } }
      limit: $limit
      offset: $offset
      order_by: $order
    ) {
      id
      picture
      created_at
      title
      url
    }
    cms_achievements_aggregate(where: { title: { _ilike: $title } }) {
      aggregate {
        count
      }
    }
  }
`;

const queryMap = {
  acara: queryAcara,
  artikel: queryArtikel,
  berita: queryBerita,
  "e-brocure": queryEBrocure,
  prestasi: queryPrestasi,
};

export { queryMap };
